import React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { Building02Icon } from '@hugeicons/core-free-icons';

function CondoTownhouse(props) {
    const className = props.className;
    const fill = props.fill;
    const size = props.size;
    return (
        <HugeiconsIcon
            icon={Building02Icon}
            className={className}
            color={fill}
            size={size}
        />
    )
};

export default CondoTownhouse;